import { inject, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import {
  Event,
  NavigationCancel,
  NavigationCancellationCode,
  NavigationEnd,
  NavigationError,
  NavigationSkipped,
  Router,
} from '@angular/router';
import { filter, map, take } from 'rxjs';

const settlesNavigation = (event: Event): boolean =>
  event instanceof NavigationEnd ||
  event instanceof NavigationError ||
  event instanceof NavigationSkipped ||
  (event instanceof NavigationCancel &&
    event.code !== NavigationCancellationCode.Redirect &&
    event.code !== NavigationCancellationCode.SupersededByNewNavigation);

export const injectInitialNavigationPending = (): Signal<boolean> =>
  toSignal(
    inject(Router).events.pipe(
      filter(settlesNavigation),
      take(1),
      map(() => false),
    ),
    { initialValue: true },
  );
